"use client";

import { useEffect } from "react";
import confetti from "canvas-confetti";

const CelebrationScreen = ({ onCelebrationEnd }) => {
  useEffect(() => {
    const myCanvas = document.createElement("canvas");
    myCanvas.style.position = "fixed";
    myCanvas.style.top = 0;
    myCanvas.style.left = 0;
    myCanvas.style.width = "100%";
    myCanvas.style.height = "100%";
    myCanvas.style.pointerEvents = "none";
    myCanvas.style.zIndex = 9999;
    document.body.appendChild(myCanvas);

    const myConfetti = confetti.create(myCanvas, { resize: true });

    // Fast celebration - multiple quick bursts
    const celebrationSequence = async () => {
      // First burst - center
      myConfetti({
        particleCount: 100,
        startVelocity: 45,
        spread: 160,
        ticks: 200,
        origin: { x: 0.5, y: 0.6 },
        colors: ["#EC5E3A", "#FFD740", "#64FFDA", "#448AFF", "#E040FB"],
      });

      // Quick side bursts
      setTimeout(() => {
        myConfetti({
          particleCount: 50,
          angle: 60,
          spread: 80,
          startVelocity: 35,
          ticks: 150,
          origin: { x: 0, y: 0.7 },
          colors: ["#69F0AE", "#FF4081", "#FFD740"],
        });
      }, 100);

      setTimeout(() => {
        myConfetti({
          particleCount: 50,
          angle: 120,
          spread: 80,
          startVelocity: 35,
          ticks: 150,
          origin: { x: 1, y: 0.7 },
          colors: ["#EC5E3A", "#448AFF", "#E040FB"],
        });
      }, 200);

      // Final burst
      setTimeout(() => {
        myConfetti({
          particleCount: 80,
          startVelocity: 40,
          spread: 120,
          ticks: 180,
          origin: { x: 0.5, y: 0.8 },
          colors: ["#EC5E3A", "#FFD740", "#64FFDA"],
        });
      }, 300);

      // End celebration after 2 seconds (much faster)
      setTimeout(() => {
        if (onCelebrationEnd) {
          onCelebrationEnd();
        }
      }, 2000);
    };

    celebrationSequence();

    return () => {
      if (document.body.contains(myCanvas)) {
        document.body.removeChild(myCanvas);
      }
    };
  }, [onCelebrationEnd]);

  return null;
};

export default CelebrationScreen;
